import { Directive, HostListener, ElementRef } from '@angular/core'

@Directive({
    selector: 'input[TwoDecimalPlaces]'
})
export class TwoDecimalPlacesDirective {
    // Allow decimal numbers and negative values
    private regex: RegExp = new RegExp(/^\d*\.?\d{0,2}$/g);
    // Allow key codes for special events. Reflect :  Backspace, tab, end, home
    private specialKeys: Array<string> = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'End', 'Home'];

    constructor(private el: ElementRef) {
    }

    CheckValidate(event: any) {
        let result = false;
        if (this.specialKeys.indexOf(event.key) !== -1) {
            result = true;
        }
        else if (event.target.selectionStart == 0 && event.target.selectionEnd == this.el.nativeElement.value.length) {
            if (String(event.key).match(this.regex))
                result = true;
            else
                result = false;
        }
        return result;
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        

        // Allow Backspace, tab, end,home and Ctrl + A
        // if (this.specialKeys.indexOf(event.key) !== -1 || (event.ctrlKey && event.keyCode == 65)) {
        if (this.CheckValidate(event) || (event.ctrlKey && event.keyCode == 65)) {
            return;
        }
        let current: string = this.el.nativeElement.value;
        let next: string = current.concat(event.key);
        if (next && !String(next).match(this.regex)) {
            event.preventDefault();
        }
    }
}